import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import type { UserCustomAttribute } from 'shared-types';

interface Props {
  attribute: UserCustomAttribute;
  optionGroupIndex: number;
  updateData: () => Promise<void>;
}

const UserAttributesOptionsDeleteGroup = ({
  attribute,
  optionGroupIndex,
  updateData
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    const data = {
      optionGroups: [
        ...attribute.optionGroups.slice(0, optionGroupIndex),
        ...attribute.optionGroups.slice(optionGroupIndex + 1)
      ].map((optionGroup) => ({
        ...optionGroup,
        conditions:
          attribute.optionGroups.length > 2 ? optionGroup.conditions : []
      }))
    };

    await api.put(`/admin/user-custom-attributes/${attribute.id}`, data);

    await updateData();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={'Delete option group'}
      category="danger"
      confirmText={'Are you sure you want to delete this option group?'}
      confirmTitle={'Delete option group'}
      onConfirm={handleConfirm}
      successMessage={messages.commonChangesSavesSuccessfully}
    />
  );
};

export default UserAttributesOptionsDeleteGroup;
